import MobileDetect from "mobile-detect";
import React, { useCallback, useMemo } from "react";
import { Zostel } from "../../../../../../assets/media/icons";

interface AppStoreLinks {
  ios: string;
  android: string;
}

interface AppDownloadSectionProps {}

const APP_STORE_LINKS: AppStoreLinks = {
  ios: "https://apps.apple.com/us/app/zostel/id1620655522",
  android:
    "https://play.google.com/store/apps/details?id=com.zostel.app.android",
};

const AppDownloadSection: React.FC<AppDownloadSectionProps> = () => {
  const device = useMemo(
    () => new MobileDetect(window.navigator.userAgent),
    []
  );
  const handleAppDownload = useCallback(() => {
    const platform = device.os() === "AndroidOS" ? "android" : "ios";
    window.location.href = APP_STORE_LINKS[platform];

    gtag("event", "app_download_click", {
      platform,
      device: device.os(),
      userAgent: device.userAgent(),
    });
  }, [device]);
  const rating = 4.5;

  return (
    <div className="flex items-center gap-4 p-4 border border-stroke-primary rounded-2xl">
      <div className="bg-orange rounded-xl w-12 h-12 flex items-center justify-center flex-shrink-0">
        <Zostel fill="#fff" className="w-6 h-6" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-sm truncate">Download Zostel App</h3>
        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs">2M Zostelers</span>
          <span className="text-xs">•</span>
          <div className="flex items-center">
            <span className="text-sm">{rating}/5</span>
            <div className="flex ml-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <svg
                  key={star}
                  className={`w-3 h-3 sm:w-4 sm:h-4 ${
                    star <= Math.floor(rating)
                      ? "text-orange"
                      : star === Math.ceil(rating)
                      ? "text-orange"
                      : "text-gray-300"
                  }`}
                  viewBox="0 0 20 20"
                >
                  {star === Math.ceil(rating) && rating % 1 !== 0 ? (
                    <>
                      <defs>
                        <linearGradient
                          id={`half-star-${star}`}
                          x1="0%"
                          y1="0%"
                          x2="100%"
                          y2="0%"
                        >
                          <stop offset="50%" stopColor="#FF5722" />
                          <stop offset="50%" stopColor="#D1D5DB" />
                        </linearGradient>
                      </defs>
                      <path
                        fill={`url(#half-star-${star})`}
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                      />
                    </>
                  ) : (
                    <path
                      fill="currentColor"
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    />
                  )}
                </svg>
              ))}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={handleAppDownload}
        className="px-3 py-2 bg-primary text-white rounded-full text-xs font-medium whitespace-nowrap"
      >
        Get App
      </button>
    </div>
  );
};

export default AppDownloadSection;
